import React, { lazy, Suspense, useEffect } from 'react';
import { LazyMotion, domAnimation } from 'framer-motion';
import { Hero } from './components/sections/Hero';
import { StickyCTA } from './components/ui/StickyCTA';
import { initMetaPixel } from './utils/metaPixel';

// Everything below the hero is code-split so it doesn't compete with the
// hero/LCP for the browser's main thread on first paint.
const TaglineBanner = lazy(() => import('./components/sections/TaglineBanner').then(mod => ({
  default: mod.TaglineBanner
})));
const Problems = lazy(() => import('./components/sections/Problems').then(mod => ({
  default: mod.Problems
})));
const Solution = lazy(() => import('./components/sections/Solution').then(mod => ({
  default: mod.Solution
})));
const Volumes = lazy(() => import('./components/sections/Volumes').then(mod => ({
  default: mod.Volumes
})));
const Bonuses = lazy(() => import('./components/sections/Bonuses').then(mod => ({
  default: mod.Bonuses
})));
const LookInside = lazy(() => import('./components/sections/LookInside').then(mod => ({
  default: mod.LookInside
})));
const ValueTable = lazy(() => import('./components/sections/ValueTable').then(mod => ({
  default: mod.ValueTable
})));
const PriceReveal = lazy(() => import('./components/sections/PriceReveal').then(mod => ({
  default: mod.PriceReveal
})));
const WhyItWorks = lazy(() => import('./components/sections/WhyItWorks').then(mod => ({
  default: mod.WhyItWorks
})));
const Testimonials = lazy(() => import('./components/sections/Testimonials').then(mod => ({
  default: mod.Testimonials
})));
const HowItWorks = lazy(() => import('./components/sections/HowItWorks').then(mod => ({
  default: mod.HowItWorks
})));
const Guarantee = lazy(() => import('./components/sections/Guarantee').then(mod => ({
  default: mod.Guarantee
})));
const FAQ = lazy(() => import('./components/sections/FAQ').then(mod => ({
  default: mod.FAQ
})));
const Objections = lazy(() => import('./components/sections/Objections').then(mod => ({
  default: mod.Objections
})));
const FinalCTA = lazy(() => import('./components/sections/FinalCTA').then(mod => ({
  default: mod.FinalCTA
})));
const Footer = lazy(() => import('./components/sections/Footer').then(mod => ({
  default: mod.Footer
})));
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <LazyMotion features={domAnimation} data-id="element-0" data-mp="8648hcyry28g">
      <div className="w-full min-h-full bg-cream font-body text-ink" data-id="element-1" data-mp="3gle9siuub3f6">
        <main data-id="element-2" data-mp="3glo2wfb6lqp3">
          <Hero data-id="element-3" data-mp="3gj1qa19fol00" />
          <Suspense fallback={null} data-id="element-4" data-mp="3bmjsjlcitmx6">
            <TaglineBanner data-id="element-5" data-mp="3bnmfji6q357t" />
            <Problems data-id="element-6" data-mp="3bk718hkvi07g" />
            <Solution data-id="element-7" data-mp="3qb7lrkyw9kjy" />
            <Volumes data-id="element-8" data-mp="3qbfv52vt67qe" />
            <Bonuses data-id="element-9" data-mp="3qbzcoihjqu3w" />
            <LookInside data-id="element-10" data-mp="3qdaienujybxn" />
            <ValueTable data-id="element-11" data-mp="3lkhbpufiwtix" />
            <PriceReveal data-id="element-12" data-mp="3lk7kk3iqsgbn" />
            <WhyItWorks data-id="element-13" data-mp="3liwl2fwbxuqc" />
            <Testimonials data-id="element-14" data-mp="3limrkic2t5fw" />
            <HowItWorks data-id="element-15" data-mp="2xudb7vxmt9w5" />
            <Guarantee data-id="element-16" data-mp="2xtv7yfcjxveq" />
            <FAQ data-id="element-17" data-mp="2xt2900ju4a75" />
            <Objections data-id="element-18" data-mp="2xsk289zjqdkz" />
            <FinalCTA data-id="element-19" data-mp="2swbsxd815elq" />
          </Suspense>
        </main>
        <Suspense fallback={null} data-id="element-20" data-mp="2svjyw6u2zoxk">
          <Footer data-id="element-21" data-mp="18e19rkmjbok1" />
        </Suspense>
        <StickyCTA data-id="element-22" data-mp="18cznek02jfn0" />
      </div>
    </LazyMotion>;
}